import * as Lucide from "lucide-react";

// Renders a Lucide icon by its string name (from site data).
export default function Icon({ name, className = "h-5 w-5", ...props }) {
  const Cmp = Lucide[name] || Lucide.Circle;
  return <Cmp className={className} {...props} />;
}
